(function () {
  'use strict';

  /* @ngdoc object
   * @name neo.home.cancellations
   * @description
   *
   */
  angular
    .module('neo.home.cancellations', [
      'ui.router',
      'neo.home.cancellations.new',
      'neo.home.cancellations.edit',
      'neo.home.cancellations.canceledMatches'
    ]);
}());
